import Api from '@/services/Api'

export default {
  register (credentials) {
    return Api().post('user/register', credentials)
  },
  login (credentials) {
    return Api().post('user/login', credentials)
  },
  changePassword (credentials) {
    return Api().post('user/changepassword', credentials)
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js